import { triggerSimpleAjax } from "../../../helpers/httpHelper";
import { LOGIN_API } from "../../../helpers/constants/ekycApiUrl";

const LoginAction = (req) => {
    return new Promise((res, rej) => {
        triggerSimpleAjax(
            LOGIN_API,
            'POST',
            req,
            (response) => {
                res(response)
            },
            (err) => {
                rej(err)
            }
        )
    });
}

export default LoginAction;